import { render, staticRenderFns } from "./cateringBedsInfo.vue?vue&type=template&id=61768f93&scoped=true&"
import script from "./cateringBedsInfo.vue?vue&type=script&lang=js&"
export * from "./cateringBedsInfo.vue?vue&type=script&lang=js&"
import style0 from "./cateringBedsInfo.vue?vue&type=style&index=0&id=61768f93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61768f93",
  null
  
)

export default component.exports